import { createContext } from 'react'
import { Socket } from 'socket.io-client'

const SocketContext = createContext<Socket<any, any> | null>(null)

export default SocketContext
